import {$app} from '../app'
import {CUSTOMER_VISIT_EVENT_TYPE_ID} from '../helpers/misc'
import App from '../app/App'

export async function addEvent (external_id) {


  try {

    const res = await $app.$api({
      action: 'carecloud_api',
      method: 'POST',
      route: 'events',
      data: {
        event: {
          event_type_id: CUSTOMER_VISIT_EVENT_TYPE_ID,
          customer_id: '{customer_id}',
          external_id
        }
      }
    })

    App.$toast("Účtenka načtena.")

    return res

  } catch (error) {

    if(error?.error_data?.invalid_params[0]?.reason === "relation_already_exists") {

      App.$toast("Účtenka již byla načtena.", "error")
      return

    }

    $app.handleError(error)

  }

}